// extracted by mini-css-extract-plugin
export default {"sidebar-footer":"styles_sidebar-footer__iIuT4"};